import React, { FC } from 'react';

import imgSrc from '~/assets/icons/logo.png';

import styles from './styles.modules.scss';

const LogoWithText: FC = () => {
  return (
    <a href="/" className={styles.container}>
      <img className={styles.container__logo} src={imgSrc} alt="Manifest" />
      <div className={styles.container__text}>Manifest Admin</div>
    </a>
  );
};

export default LogoWithText;
